import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { AuthProvider } from "react-oidc-context";

// const cognitoAuthConfig = {
//   authority: "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_cIHambCWK",
//   client_id: "2enh0qi3utq93k3i8rt3egh9pp",
//   redirect_uri: "https://d31y3v1lspc201.cloudfront.net/index.html",
//   response_type: "code",
//   scope: "phone openid email",
// };

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_gV1a5rD9Q",
  client_id: "6mudkj0ftuk2qq6hgc8v856jfr",
  redirect_uri: "https://www.lilbitofhope.com/index.html",
  response_type: "code",
  scope: "phone openid email",
};


const root = ReactDOM.createRoot(document.getElementById('root'));

// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
